/**
 * 弹窗标题栏拖拽指令
 * 用法: <el-dialog v-dialog-drag ...>
 * 传 false 可禁用: <el-dialog v-dialog-drag="false">
 */

function resetDialogPosition(el) {
  const dialogEl = el.querySelector('.el-dialog')
  if (!dialogEl) return
  dialogEl.style.margin = ''
  dialogEl.style.left = ''
  dialogEl.style.top = ''
  dialogEl.style.transform = ''
}

function bindDragHandlers(el, state) {
  const dialogEl = el.querySelector('.el-dialog')
  const headerEl = el.querySelector('.el-dialog__header')
  if (!dialogEl || !headerEl) return

  if (state.cleanup) {
    state.cleanup()
    state.cleanup = null
  }

  headerEl.style.cursor = 'move'
  headerEl.style.userSelect = 'none'

  let dragging = false
  let startX = 0
  let startY = 0
  let initialX = 0
  let initialY = 0

  const onMouseDown = (e) => {
    if (e.target.closest('.el-dialog__headerbtn')) return

    dragging = true
    startX = e.clientX
    startY = e.clientY
    const rect = dialogEl.getBoundingClientRect()
    initialX = rect.left
    initialY = rect.top
    e.preventDefault()
  }

  const onMouseMove = (e) => {
    if (!dragging) return

    const deltaX = e.clientX - startX
    const deltaY = e.clientY - startY
    let newX = initialX + deltaX
    let newY = initialY + deltaY
    const maxX = window.innerWidth - dialogEl.offsetWidth
    const maxY = window.innerHeight - dialogEl.offsetHeight
    newX = Math.max(0, Math.min(newX, maxX))
    newY = Math.max(0, Math.min(newY, maxY))

    dialogEl.style.left = `${newX}px`
    dialogEl.style.top = `${newY}px`
    dialogEl.style.margin = '0'
  }

  const onMouseUp = () => {
    dragging = false
  }

  headerEl.addEventListener('mousedown', onMouseDown)
  document.addEventListener('mousemove', onMouseMove)
  document.addEventListener('mouseup', onMouseUp)

  state.cleanup = () => {
    headerEl.removeEventListener('mousedown', onMouseDown)
    document.removeEventListener('mousemove', onMouseMove)
    document.removeEventListener('mouseup', onMouseUp)
    headerEl.style.cursor = ''
    headerEl.style.userSelect = ''
  }
}

function setupDialogDrag(el, binding, vnode) {
  if (binding.value === false) return

  const dialogVm = vnode.componentInstance
  if (!dialogVm) return

  const state = { cleanup: null, unwatch: null }
  el._dialogDragState = state

  const handleVisibleChange = (visible) => {
    if (visible) {
      dialogVm.$nextTick(() => bindDragHandlers(el, state))
    } else {
      resetDialogPosition(el)
      if (state.cleanup) {
        state.cleanup()
        state.cleanup = null
      }
    }
  }

  state.unwatch = dialogVm.$watch('visible', handleVisibleChange)

  if (dialogVm.visible) {
    dialogVm.$nextTick(() => bindDragHandlers(el, state))
  }
}

function teardownDialogDrag(el) {
  const state = el._dialogDragState
  if (!state) return

  if (state.unwatch) state.unwatch()
  if (state.cleanup) state.cleanup()
  resetDialogPosition(el)
  delete el._dialogDragState
}

export default {
  inserted(el, binding, vnode) {
    setupDialogDrag(el, binding, vnode)
  },

  update(el, binding, vnode) {
    if (binding.value === false) {
      teardownDialogDrag(el)
      return
    }
    if (!el._dialogDragState) {
      setupDialogDrag(el, binding, vnode)
    }
  },

  unbind(el) {
    teardownDialogDrag(el)
  }
}
